var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',_vm._b({class:_vm.svgClass,attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('click')}}},'svg',_vm.$attrs,false),[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }